<template>
  <div id="app">
    <router-view></router-view>
    <div class="loading-mask" v-if="isLoading"><span>{{loadingMessage}}</span></div>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      isLoading:false,
      loadingMessage:'Authenticating...',
      isDevMode: true
    }
  },
  
  mounted() {
    console.log(`App.mounted()`);
    // listen for auth state changes (triggers automatic login of active users that didn't logout)
      this.$firebase.auth().onAuthStateChanged((user) => {
        this.isLoading = true;
        if (user != null) {
          if (!this.$store.state.users.userLoggedIn) {
            // update store with user data
            this.$store.dispatch('users/loginUser', user)
              .then(() => {
                // route user to home view from /login or /signup
                if (this.$route.path === '/login' || this.$route.path === '/signup') {
                  this.$router.push('/');
                }
                this.isLoading = false;
              })
          } else {
            // what changed (if anything)
            this.isLoading = false;
          }
        } else {
          // User logged out
          this.$store.dispatch('users/setUserStatus', false)
            .then(() => {
              // move user to /login if they are in view that requires login status
              if (this.$route.meta.requiresLogin) {
                this.$router.push('/login');
              }
              this.isLoading = false;
            })
            .catch(this.handleError)
        }
      });
      // initialize firestore-disable deprecated features
      let db = this.$firebase.firestore();
      console.dir(db.collection);
  },
  
  methods: {
      handleError(err) {
        console.warn('App.handleError()');
        console.dir(err);
        this.isLoading = false;
      }
    }
}
</script>

<style>
  button.add-card {
    position:absolute;
    right: 5px;
  }
</style>
